// extracted by mini-css-extract-plugin
export var shake = "_1d-0";